import { Strings } from "@app/constants";

export const headersSteps = [
  { label: Strings.sellCarStepper.brand, text: "1" },
  { label: Strings.sellCarStepper.model, text: "2" },
  {
    label: Strings.sellCarStepper.year,
    text: "3",
  },
  { label: Strings.sellCarStepper.variant, text: "4" },
  { label: Strings.sellCarStepper.kMsDriven, text: "5" },
  { label: Strings.sellCarStepper.sellingTime, text: "6" },
  { label: Strings.sellCarStepper.carInfo, text: "7" },
  { label: Strings.sellCarStepper.images, text: "8" },
  { label: Strings.sellCarStepper.mobileNo, text: "9" },
];
